// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"767":"27a64408","877":"61b83ad9"}[chunkId] + ".chunk.js";
};